import { useTranslation } from 'react-i18next';
import { PRINT_SHEET_CLASS as C } from '../printStyles';
import { RoutinePrintQuestion } from './types';

export const SignaturePrintQuestion: RoutinePrintQuestion = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={`${C}__signature`} />
      <span className={`${C}__fieldLabel`}>
        {t('routine.print.signature', 'Signature')}
      </span>
    </div>
  );
};
